import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "prescriptions",
        path: "/prescriptions",
        component: () => import("./components/PrescriptionsSingleTileSet.vue"),
        props: { tileId: "prescriptions-list-tile" }
    }
];

export default routes;
